var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1313_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04152 10.3147C6.90142 10.3147 5.1665 12.0496 5.1665 14.1897V24.523H7.74981V14.1897C7.74981 13.4763 8.32815 12.898 9.04152 12.898H40.0416V10.3147H9.04152Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04152 49.0649C8.32815 49.0649 7.74981 48.4866 7.74981 47.7732V34.8564H5.1665V47.7732C5.1665 49.9133 6.90142 51.6482 9.04152 51.6482H21.9583V49.0649H9.04152Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9548 52.3959L9.58521 21.0264C9.08086 20.5221 8.26323 20.5221 7.75875 21.0264L0.378177 28.4071C-0.126059 28.9114 -0.126059 29.729 0.378177 30.2335L31.7478 61.603C31.9899 61.8453 32.3185 61.9814 32.6609 61.9814C33.0035 61.9813 33.3319 61.8452 33.5741 61.603L40.9547 54.2224C41.459 53.7179 41.459 52.9003 40.9548 52.3959ZM32.6609 58.8633L3.11781 29.3202L8.67204 23.766L38.2152 53.3092L32.6609 58.8633Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8331 49.0649H37.458V51.6482H51.6664V58.1066C51.6664 58.8199 52.2447 59.3983 52.9581 59.3983H56.8331C59.6865 59.3983 61.9998 57.0851 61.9998 54.2315C61.9998 51.3781 59.6865 49.0649 56.8331 49.0649ZM56.8331 56.815H54.2498V51.6482H56.8331C58.2598 51.6482 59.4164 52.8048 59.4164 54.2315C59.4164 55.6584 58.2598 56.815 56.8331 56.815Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8333 10.3147H50.375V12.898H56.8333C58.2601 12.898 59.4166 14.0546 59.4166 15.4813V54.2315H61.9999V15.4813C62 12.6278 59.6868 10.3147 56.8333 10.3147Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6288 36.5263L19.7534 40.4016L21.5801 42.2283L25.4554 38.3529L23.6288 36.5263Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4622 31.3595L14.5869 35.2349L16.4136 37.0615L20.2889 33.1862L18.4622 31.3595Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7928 41.6928L24.9175 45.5681L26.7441 47.3948L30.6195 43.5194L28.7928 41.6928Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9618 46.8622L30.0864 50.7375L31.9131 52.5642L35.7884 48.6889L33.9618 46.8622Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2918 26.1928L9.4165 30.0681L11.2432 31.8948L15.1185 28.0194L13.2918 26.1928Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7146 2.88501L53.9294 1.09996C52.419 -0.341913 50.0419 -0.341913 48.5315 1.09996L28.8904 20.7411C28.3861 21.2454 28.3861 22.0631 28.8904 22.5675L34.247 27.9241C34.4886 28.1673 34.8175 28.3035 35.1602 28.3026C35.5027 28.3024 35.8311 28.1663 36.0733 27.9241L55.7146 8.2829C55.7152 8.2823 55.7158 8.28169 55.7164 8.28109C57.206 6.79054 57.2051 4.37459 55.7146 2.88501ZM53.8894 6.45523L35.1602 25.1844L31.63 21.6542L50.3593 2.9263C50.8471 2.46021 51.6153 2.46021 52.1031 2.9263L53.8894 4.71014C53.8896 4.71038 53.8898 4.7105 53.89 4.71074C54.3715 5.19258 54.3713 5.97364 53.8894 6.45523Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7459 25.7863L29.1711 27.6476L31.0324 22.0637L28.5782 21.2461L25.8992 29.2815C25.8554 29.4133 25.833 29.5512 25.833 29.69C25.8331 30.4034 26.4116 30.9816 27.125 30.9813C27.2617 30.9818 27.3977 30.9609 27.528 30.9193L35.5634 28.2404L34.7459 25.7863Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7861 4.66993L44.9595 6.49658L50.3162 11.8533L52.1429 10.0267L46.7861 4.66993Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5001 28.3979H27.125V30.9813H46.5001V28.3979Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6663 28.3979H49.083V30.9813H51.6663V28.3979Z",
    fill: "#185ADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8333 28.3979H54.25V30.9813H56.8333V28.3979Z",
    fill: "#185ADB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1313_1539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.186797e1d6761dc42b634816a33c5deb.svg";
export { ForwardRef as ReactComponent };